import React, { useEffect } from 'react';
import { Button, Title, Text } from '@bambuser-ui';
import { LANDING } from 'constants/routes.js';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import { useNavigationFrameContext, TOPBAR } from 'contexts/NavigationFrameContext.jsx';
import { useHistory } from 'react-router-dom';

const NotFoundPage = () => {
  const history = useHistory();
  const { labels } = useLocalization(getLabels);
  const { overrideShowFrame } = useNavigationFrameContext();


  useEffect(() => {
    overrideShowFrame(TOPBAR, false);
    return () => {
      overrideShowFrame(TOPBAR, null);
    };
  }, [overrideShowFrame]);

  const goBack = () => {
    history.goBack();
  };

  const goHome = () => {
    history.push(LANDING);
  };

  return (
    <div
      style={styles.wrapper}
    >
      <div style={styles.container}>
        <Title type="h1">{labels.pageTitle}</Title>
        <Title type="h2">{labels.notFoundTitle}</Title>
        <Text type="body" style={styles.text}>{labels.notFoundDescription}</Text>
        <Button type="primary" style={styles.topButton} onClick={goBack}>{labels.goBackButtonLabel}</Button>
        <Button type="secondary" onClick={goHome}>{labels.goHomeButtonLabel}</Button>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    textAlign: 'center',
    maxWidth: 400,
  },
  text: {
    margin: '24px 0',
  },
  topButton: {
    marginBottom: 12,
  },
};

const getLabels = (getText) => ({
  pageTitle: getText('notFound.pageTitle'),
  notFoundTitle: getText('notFound.notFoundTitle'),
  notFoundDescription: getText('notFound.notFoundDescription'),
  goBackButtonLabel: getText('notFound.goBackButtonLabel'),
  goHomeButtonLabel: getText('notFound.goHomeButtonLabel'),
});

export default NotFoundPage;
